<div class="container-fluid pt-3">
    <div class="row pb-3">
        <div class="col d-flex justify-content-end">
            <button class="btn btn-outline-info" (click)="createLotAttribute()">
				<i class="fa fa-asterisk fa-md" aria-hidden="true"></i> {{ 'new' | translate }}
			</button>
        </div>
    </div>
    <div class="table-responsive">
        <table class="table table-striped table-bordered table-curved table-fixed" *ngIf="attributes.length else nodata">
            <thead>
            <tr>
                <th scope="col" jhiTranslate="attributes.variable">Variable</th>
                <th scope="col" jhiTranslate="attributes.variable-description" style="width: 15%">Description</th>
                <th scope="col" jhiTranslate="attributes.value">Value</th>
                <th scope="col" jhiTranslate="attributes.date">Date</th>
                <th scope="col" jhiTranslate="attributes.location" style="width: 20%">Location</th>
                <th scope="col" jhiTranslate="attributes.actions" class="fit">Actions</th>
            </tr>
            </thead>
            <tbody>
            <tr *ngFor="let attribute of attributes">
                <td>
                    <a [routerLink]="['/', { outlets: { popup: 'variable-details-popup' }}]"
                       [queryParams]="{ variableId: attribute.variableId }" queryParamsHandling="merge">{{attribute.variableName}}</a>
                </td>
                <td>{{attribute.variableDescription}}</td>
                <td class="word-wrap" [class.accepted-value]="!isValidValue(attribute)">
                    <truncate-span [textInput]="attribute.value" [maxLength]="MAX_ATTRIBUTE_DISPLAY_SIZE"></truncate-span>
                </td>
                <td>{{attribute.date}}</td>
                <td>{{attribute.locationName}}</td>
                <td class="fit" >
                    <button class="btn btn-outline-info btn-sm me-2" (click)="editLotAttribute(attribute)">
                        <i class="fa fa-edit fa-md" aria-hidden="true"></i>
                    </button>
                    <button class="btn btn-outline-info btn-sm me-2" (click)="deleteLotAttribute(attribute)">
                        <i class="fa fa-trash fa-md" aria-hidden="true"></i>
                    </button>
                    <button class="btn btn-outline-info btn-sm me-2" (click)="gotoFiles(attribute)" *ngIf="attribute.hasFiles && isFileStorageConfigured">
                        <i class="fa fa-file fa-md" aria-hidden="true"></i>
                    </button>
                </td>
            </tr>
            </tbody>
        </table>
        <ng-template #nodata>
            <table class="table table-striped table-bordered table-curved">
                <thead>
                <tr>
                    <th></th>
                </tr>
                </thead>
                <tbody>
                <tr>
                    <td jhiTranslate="no.data"></td>
                </tr>
                </tbody>
            </table>
        </ng-template>
    </div>
</div>
